import { Content } from './Content'
import { FilteredProvider } from './Context'
import { FiltersDetailed } from './FiltersDetailed'
import { Container } from './style'

export function FilteredInformations() {
    return (
        <Container>
            <FilteredProvider>
                <Content />
                <FiltersDetailed />
            </FilteredProvider>
        </Container>
    )
}
